export default function getFields(vm) {
  const fields = [
    {
      key: 'engineOffDate',
      label: 'global.field.date',
      header: 'cutOffDate',
      thClass: 'mc-table--170',
    },
    {
      key: 'engineOffStatus',
      label: 'global.object.status',
      header: 'engineOffStatus',
      thClass: 'mc-table--170',
    },
    {
      key: 'licensePlate',
      label: 'global.object.licensePlate',
      header: 'licensePlate',
      thClass: 'mc-table--170',
    },
    {
      key: 'engineOffGeolocation',
      label: 'global.object.geolocation',
      header: 'engineOffGeolocation',
    },
  ]

  fields.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      item.children.forEach((child) => {
        child.label = vm.$t(child.label)
      })
    }
    item.label = vm.$t(item.label)
  })

  return fields
}
